<header class="app-header" role="banner">
    <mat-toolbar color="primary" class="app-toolbar toolbar--light">
        <div class="toolbar-section left">
            <button type="button" class="logo-btn" aria-label="Veralora Logo" (click)="onLogoClick()">
                <img src="/assets/logo.svg" alt="Veralora Logo" class="logo-img" />
            </button>
        </div>
    </mat-toolbar>
</header>
<mat-divider></mat-divider>